const urlApi = 'https://res.cloudinary.com/prism-medical/image/fetch';

function imageFill(src, size) {
    const options = `w_${size},h_${size},c_fill`;

    return `${urlApi}/${options}/${src}`;
}

function imageFit(src, size) {
    const options = `w_${size},h_${size},c_fit`;

    return `${urlApi}/${options}/${src}`;
}

function imageCrop(src, size) {
    const options = `w_${size},h_${size},c_crop`;

    return `${urlApi}/${options}/${src}`;
}

function castoumeImageFit(src, width, height) {
    const options = `w_${width},h_${height},c_fit`;

    return `${urlApi}/${options}/${src}`;
}

export {
    imageCrop,
    imageFit,
    imageFill,
    castoumeImageFit
};
